import React, { ChangeEvent, FC, useCallback, useEffect, useRef } from 'react';
import { Badge, TabsActions } from '@material-ui/core';
import {
  StyledTab,
  StyledTabs,
} from 'src/modules/shared/components/SubHeader/TrajectorySubheader/Atoms';
import { useAppDispatch, useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import { useGetNotificationsQuery } from 'src/modules/shared/slices/comunications/notifications/notificationsApi';
import { setSelectedTab } from 'src/modules/shared/slices/comunications/notifications/notificationsSlice';
import { StyledTabLabel } from './styled';

export const NotificationTabMenu: FC = () => {
  const dispatch = useAppDispatch();
  const containerRef = useRef(null);
  const actionRef = useRef<TabsActions | null>(null);
  const selectedTab = useAppSelector((state) => state.notifications.selectedTab);

  const { data: dataRead } = useGetNotificationsQuery(true, {
    skip: selectedTab === 1,
  });

  useGetNotificationsQuery(false, {
    skip: selectedTab === 0,
  });

  useEffect(() => {
    if (dataRead?.length === 0) {
      dispatch(setSelectedTab(1));
    }
  }, [dataRead?.length, dispatch]);

  useEffect(() => {
    const ro = new ResizeObserver(() => {
      if (actionRef.current && containerRef.current) {
        actionRef.current.updateIndicator();
      }
    });

    if (containerRef.current) {
      ro.observe(containerRef.current);
    }
  }, []);

  const handleSiderbarChange = useCallback(
    (event: ChangeEvent<{}>, newValue: number) => {
      return dispatch(setSelectedTab(newValue));
    },
    [dispatch]
  );

  return (
    <div ref={containerRef}>
      <StyledTabs
        action={actionRef}
        value={selectedTab}
        indicatorColor="primary"
        onChange={handleSiderbarChange}
        variant="fullWidth"
      >
        <StyledTab
          label={
            <StyledTabLabel>
              <span>Nieuw</span>
              <Badge
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                style={{ marginLeft: 8 }}
                badgeContent={dataRead?.length ?? 0}
                color="primary"
              ></Badge>
            </StyledTabLabel>
          }
        />
        <StyledTab label={'Gelezen'} />
      </StyledTabs>
    </div>
  );
};
